// src/components/AddMoreItems.jsx
import { useEffect, useState } from "react";
import { Package } from "lucide-react";

export default function AddMoreItems() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProducts() {
      try {
        const response = await fetch("/api/collections/");
        const data = await response.json();

        let allProducts = [];
        if (data.products && Array.isArray(data.products)) {
          allProducts = data.products;
        } else if (Array.isArray(data)) {
          allProducts = data;
        }

        const newest = allProducts
          .sort((a, b) => (b.id || 0) - (a.id || 0))
          .slice(0, 8);

        setProducts(newest);
      } catch (error) {
        console.error("Error fetching add more items:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchProducts();
  }, []);

  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center justify-center mb-10">
          <h2 className="text-3xl md:text-4xl font-semibold text-[#4b2e05] flex items-center gap-2">
            <Package className="w-7 h-7 text-[#a47148]" />
            Add More Items
          </h2>
          <a
            href="/collections"
            className="mt-2 text-black text-sm font-medium hover:underline hover:text-[#4b2e05] transition-all"
          >
            Show All
          </a>
        </div>

        {loading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : products.length === 0 ? (
          <p className="text-center text-gray-600">No products available.</p>
        ) : (
          <div className="grid gap-8 grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
            {products.map((product) => {
              // EXACT SAME IMAGE LOGIC AS NewArrivals.jsx
              let firstImage = null;

              if (product.images) {
                if (Array.isArray(product.images)) {
                  firstImage = product.images[0];
                } else if (typeof product.images === "object" && !Array.isArray(product.images)) {
                  for (const colorImages of Object.values(product.images)) {
                    if (Array.isArray(colorImages) && colorImages[0]) {
                      firstImage = colorImages[0];
                      break;
                    }
                  }
                }
              }

              const imageUrl = firstImage?.startsWith('http')
                ? firstImage
                : firstImage
                ? `${firstImage}`
                : null;

              return (
                <a
                  key={product.id}
                  href={`/product/${product.id}`}
                  className="group block bg-white rounded-xl shadow hover:shadow-lg transition-all duration-300 p-3 border border-gray-100"
                >
                  <div className="relative h-40 bg-gray-50 rounded-md overflow-hidden">
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt={product.name}
                        className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                        onError={(e) => {
                          e.target.src = "https://placehold.co/200x250/cccccc/999999?text=No+Image";
                        }}
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-400 text-xs">
                        No Image
                      </div>
                    )}
                  </div>

                  <h3 className="mt-3 text-sm font-semibold text-gray-800 line-clamp-2 group-hover:text-black">
                    {product.name}
                  </h3>

                  <p className="text-gray-700 mt-1 font-bold text-sm">
                    ₹{product.offer_price || product.price}
                  </p>
                </a>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}